/**
 * Shopify mounts #shopify-pc__banner after theme CSS.
 * Force the one-line pill host. Do not lock display/overflow/transform —
 * those break Accept, Decline, and Manage preferences.
 */
(function () {
  var isLocalDev =
    location.hostname === '127.0.0.1' ||
    location.hostname === 'localhost' ||
    document.documentElement.classList.contains('is-local-dev');

  function hideLocalBanner(el) {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
    el.style.setProperty('display', 'none', 'important');
  }

  var HOST = [
    ['position', 'fixed'],
    ['top', 'auto'],
    ['right', '0'],
    ['bottom', '1.5rem'],
    ['left', '0'],
    ['width', 'min(52rem, calc(100vw - 2rem))'],
    ['max-width', 'min(52rem, calc(100vw - 2rem))'],
    ['height', 'auto'],
    ['min-height', '3.5rem'],
    ['max-height', 'none'],
    ['margin', '0 auto'],
    ['overflow', 'visible'],
    ['border-radius', '999px'],
    ['background', 'rgba(255, 255, 255, 0.58)'],
    ['-webkit-backdrop-filter', 'blur(18px) saturate(160%)'],
    ['backdrop-filter', 'blur(18px) saturate(160%)'],
    ['border', '1px solid rgba(255, 255, 255, 0.45)'],
    ['box-shadow', '0 18px 48px rgba(25, 25, 25, 0.16)'],
    ['z-index', '2147483000']
  ];

  var UNLOCK = ['display', 'transform'];

  function applyHost(el) {
    UNLOCK.forEach(function (prop) {
      el.style.removeProperty(prop);
    });
    HOST.forEach(function (pair) {
      el.style.setProperty(pair[0], pair[1], 'important');
    });
    el.setAttribute('data-babeina-pc-styled', '1');
  }

  function run() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el) return false;
    if (isLocalDev) {
      hideLocalBanner(el);
      hideLocalBanner(document.getElementById('shopify-pc__prefs__dialog'));
      return true;
    }
    applyHost(el);
    return true;
  }

  var OPTIONAL_INPUTS = [
    'shopify-pc__prefs__preferences-input',
    'shopify-pc__prefs__marketing-input',
    'shopify-pc__prefs__analytics-input'
  ];

  function placeCloseButton() {
    var header = document.querySelector('#shopify-pc__prefs__dialog header');
    var close = document.getElementById('shopify-pc__prefs__header-close');
    if (!header || !close || close.parentNode !== header) return;
    if (header.lastElementChild === close) return;
    header.appendChild(close);
  }

  function uncheckOptionalDefaults() {
    OPTIONAL_INPUTS.forEach(function (id) {
      var input = document.getElementById(id);
      if (!input || input.getAttribute('data-babeina-pc-defaulted') === '1') return;
      if (input.disabled || input.getAttribute('aria-readonly') === 'true') return;
      input.setAttribute('data-babeina-pc-defaulted', '1');
      if (!input.checked) return;
      input.checked = false;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  run();
  placeCloseButton();
  uncheckOptionalDefaults();

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('#shopify-pc__banner__btn-manage-prefs')) {
      window.setTimeout(function () {
        placeCloseButton();
        uncheckOptionalDefaults();
      }, 30);
      window.setTimeout(function () {
        placeCloseButton();
        uncheckOptionalDefaults();
      }, 200);
    }
  }, true);

  var observer = new MutationObserver(function () {
    run();
    placeCloseButton();
    uncheckOptionalDefaults();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
    run();
    placeCloseButton();
    uncheckOptionalDefaults();
  }, 8000);
})();
